import type { TaskType } from '../types';

/**
 * Get the API base URL, ensuring it ends with a trailing slash.
 * Falls back to hardcoded URL only in development/testing scenarios.
 */
const getApiBaseUrl = (): string => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (!envUrl) {
    console.warn('REACT_APP_API_URL is not defined, using fallback URL');
    return 'https://54.242.131.38:8080/';
  }
  // Ensure trailing slash
  return envUrl.endsWith('/') ? envUrl : `${envUrl}/`;
};

export const API_BASE_URL = getApiBaseUrl();

/**
 * Constructs the image base URL for a specific task type.
 * @param type - The task type: 'mmc', 'detection', or 'plate'
 * @returns The full image base URL for that type
 */
export const getImageBaseUrl = (type: TaskType): string => {
  return `${API_BASE_URL}images/type/${type}`;
};

/**
 * Pre-computed image base URLs for each type.
 */
export const IMAGE_BASE_URLS = {
  mmc: getImageBaseUrl('mmc'),
  detection: getImageBaseUrl('detection'),
  plate: getImageBaseUrl('plate'),
} as const;
